import { ProgressBar } from '@taxdown/piccolo-web';
import * as Styled from '../styles';

const Progress = ({ progress }: { progress: number }): JSX.Element => {
  return (
    <Styled.ProgressContainer>
      <ProgressBar filled={progress} baseColor="" filledColor="" />
    </Styled.ProgressContainer>
  );
};

export default Progress;
